import React from 'react';
import { ShieldWarning } from '@phosphor-icons/react';

const LOCAL = ['localhost', '127.0.0.1'];
export const isInsecureConnection = () =>
  typeof window !== 'undefined' && window.location.protocol === 'http:' && !LOCAL.includes(window.location.hostname);

// Shown instead of the whole app when loaded without HTTPS — no login, registration or payment possible.
export const InsecureConnectionGuard = () => {
  const retry = () => window.location.replace(`https://${window.location.host}${window.location.pathname}${window.location.search}`);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="insecure-connection-guard">
      <div className="max-w-md w-full bg-white border border-amber-200 rounded-2xl p-8 text-center shadow-sm">
        <ShieldWarning size={48} weight="duotone" className="mx-auto text-amber-500 mb-4" />
        <h1 className="text-2xl font-black text-slate-900 mb-2">Sichere Verbindung nicht verfügbar</h1>
        <p className="text-slate-600 mb-1">Bitte später erneut versuchen. Zu deinem Schutz sind Login, Registrierung und Zahlungen gesperrt, solange keine sichere Verbindung besteht.</p>
        <p className="text-slate-400 text-sm mb-6">Secure connection not available — please try again later. Login, sign-up and payments are blocked for your protection.</p>
        <button type="button" onClick={retry} className="px-6 py-3 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-bold transition-colors" data-testid="insecure-retry-btn">
          Erneut versuchen
        </button>
      </div>
    </div>
  );
};

export default InsecureConnectionGuard;
